var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58485 14.1258V7.6828H6.66643L6.97862 5.17111H4.58485V3.56781C4.58485 2.84084 4.77846 2.34543 5.7833 2.34543L7.06291 2.34488V0.0983393C6.84166 0.0684749 6.0821 0 5.19796 0C3.35176 0 2.0879 1.1703 2.0879 3.31905V5.17111H0V7.6828H2.0879V14.1258H4.58485Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookImg);
export default __webpack_public_path__ + "static/media/facebook-img.2056b04a70497454a283c26cf0419500.svg";
export { ForwardRef as ReactComponent };